import styled from "styled-components";
export const FlexParent = styled.div `
  flex-direction: ${props => props.vertical ? "column" : "row"};
  display : flex;
`;
